/**
 * MaturityBadge — sdileny prvek pro zobrazeni maturity/tier modulu.
 * Pouziti: <MaturityBadge tier="dev" /> nebo <MaturityBadge maturity="beta" />
 */
import { FlaskConical, Shield } from 'lucide-react';

export type Tier = 'core' | 'stable' | 'test' | 'dev';

const STYLES: Record<Tier, { bg: string; text: string; label: string; icon: 'shield' | 'flask' }> =
  {
    core: {
      bg: 'bg-blue-500/10 border-blue-500/20',
      text: 'text-blue-400',
      label: 'CORE',
      icon: 'shield',
    },
    stable: {
      bg: 'bg-green-500/10 border-green-500/20',
      text: 'text-green-400',
      label: 'STABLE',
      icon: 'shield',
    },
    test: {
      bg: 'bg-yellow-500/10 border-yellow-500/20',
      text: 'text-yellow-400',
      label: 'BETA',
      icon: 'flask',
    },
    dev: {
      bg: 'bg-purple-500/10 border-purple-500/20',
      text: 'text-purple-400',
      label: 'DEV',
      icon: 'flask',
    },
  };

export function maturityToTier(maturity?: string): Tier {
  switch (maturity) {
    case 'production':
    case 'stable':
      return 'stable';
    case 'testing':
    case 'beta':
      return 'test';
    case 'development':
    case 'dev':
    case 'dev-only':
      return 'dev';
    default:
      return 'stable';
  }
}

interface Props {
  tier?: Tier;
  maturity?: string;
  showStable?: boolean; // default: stable se nezobrazuje
}

export function MaturityBadge({ tier: tierProp, maturity, showStable = false }: Props) {
  const tier = tierProp ?? maturityToTier(maturity);
  if (tier === 'stable' && !showStable) return null;
  const s = STYLES[tier];
  const Icon = s.icon === 'shield' ? Shield : FlaskConical;
  return (
    <span
      className={'inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded border text-[9px] font-bold tracking-wider ' +
        s.bg + ' ' + s.text}
    >
      <Icon size={8} />
      {s.label}
    </span>
  );
}
